(() => {
  const root = document.querySelector('[data-drt-system-collection]');
  if (!root) return;

  const modal = root.querySelector('[data-drt-image-modal]');
  const modalImg = root.querySelector('[data-drt-image-modal-img]');

  const getQty = (card) => {
    const input = card.querySelector('[data-drt-qty-input]');
    const value = parseInt(input?.value || '1', 10);
    return Number.isFinite(value) && value > 0 ? value : 1;
  };

  const setQty = (card, qty) => {
    const input = card.querySelector('[data-drt-qty-input]');
    if (!input) return;
    input.value = Math.max(1, qty);
  };

  const openImageModal = (src, alt) => {
    if (!modal || !modalImg || !src) return;
    modalImg.src = src;
    modalImg.alt = alt || '';
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  };

  const closeImageModal = () => {
    if (!modal || !modalImg) return;
    modal.hidden = true;
    modalImg.src = '';
    modalImg.alt = '';
    document.documentElement.style.overflow = '';
  };

  root.addEventListener('click', async (event) => {
    const zoom = event.target.closest('[data-drt-image-zoom]');
    if (zoom) {
      openImageModal(zoom.getAttribute('data-zoom-src'), zoom.getAttribute('data-zoom-alt'));
      return;
    }

    if (event.target === modal || event.target.closest('[data-drt-image-close]')) {
      closeImageModal();
      return;
    }

    const minus = event.target.closest('[data-drt-qty-minus]');
    if (minus) {
      const card = minus.closest('[data-drt-product-card]');
      setQty(card, getQty(card) - 1);
      return;
    }

    const plus = event.target.closest('[data-drt-qty-plus]');
    if (plus) {
      const card = plus.closest('[data-drt-product-card]');
      setQty(card, getQty(card) + 1);
      return;
    }

    const addOne = event.target.closest('[data-drt-add-one]');
    if (addOne) {
      const card = addOne.closest('[data-drt-product-card]');
      const variantId = addOne.getAttribute('data-variant-id');
      const quantity = getQty(card);
      await addItemsToCart([{ id: variantId, quantity }], addOne);
      return;
    }

    const addSelected = event.target.closest('[data-drt-add-selected]');
    if (addSelected) {
      const selected = Array.from(root.querySelectorAll('[data-drt-product-select]:checked:not(:disabled)'));
      const items = selected.map((checkbox) => {
        const card = checkbox.closest('[data-drt-product-card]');
        return {
          id: checkbox.getAttribute('data-variant-id'),
          quantity: getQty(card)
        };
      }).filter((item) => item.id);

      if (!items.length) {
        addSelected.textContent = 'Select items first';
        setTimeout(() => { addSelected.textContent = 'Add selected to cart'; }, 1600);
        return;
      }

      await addItemsToCart(items, addSelected);
      return;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeImageModal();
  });

  root.addEventListener('change', (event) => {
    const selectAll = event.target.closest('[data-drt-select-all]');
    if (!selectAll) return;

    root.querySelectorAll('[data-drt-product-select]:not(:disabled)').forEach((checkbox) => {
      checkbox.checked = selectAll.checked;
    });
  });

  async function addItemsToCart(items, button) {
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      for (const item of items) {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(item)
        });

        if (!response.ok) {
          throw new Error('Cart add failed');
        }
      }

      button.textContent = 'Added';
      setTimeout(() => {
        window.location.href = '/cart';
      }, 500);
    } catch (error) {
      console.error(error);
      button.textContent = 'Try again';
      button.disabled = false;
      setTimeout(() => { button.textContent = originalText; }, 1600);
    }
  }
})();
